module.exports = __webpack_public_path__ + "img/feed-button.59d1ed32.svg";